module.exports = __webpack_public_path__ + "static/handshake-446cbaff32c298ea57f6a47518166e37.svg";